import React, { useState } from 'react';
import { convertFromString } from 'utils/date';
import { formatDate } from 'utils/formatter';
import {
  getRecurrentModalStorage as getRecurrentModalStorage_,
  setRecurrentModalStorage,
  RecurrentModalProps,
} from 'hooks/useRecurrentModal';
import { useModal } from 'hooks/useModal';
import { DividendQuestionaryModal } from './currentModal/DividendQuestionaryModal';
import { AndroidReviewModal } from './currentModal/AndroidReviewModal';

const ModalIDArr = ['androidReview', 'dividendQuestionary'] as const;
export type ModalID = typeof ModalIDArr[keyof typeof ModalIDArr];

export const getRecurrentModalStorage = (modalID: ModalID) => {
  const recurrentModal = getRecurrentModalStorage_();

  const targetRecurrentModal = recurrentModal?.find(
    list => list.id === modalID
  );
  const otherRecurrentModal = recurrentModal?.filter(
    list => list.id !== modalID
  );

  return { recurrentModal, targetRecurrentModal, otherRecurrentModal };
};

const RecurrentModalInternal = ({ modalID }: { modalID: ModalID }) => {
  const [isShow, { hideModal }] = useModal(true);

  const initialIsNotShowAgain = false;
  const [isNotShowAgain, setIsNotShowAgain] = useState<boolean>(
    initialIsNotShowAgain
  );

  const {
    recurrentModal,
    targetRecurrentModal,
    otherRecurrentModal,
  } = getRecurrentModalStorage(modalID);

  const newRecurrentModal = {
    id: modalID,
    readDay: null,
    hidden: false,
  } as RecurrentModalProps;
  if (recurrentModal === null || recurrentModal === undefined) {
    setRecurrentModalStorage([newRecurrentModal]);
  }

  if (
    recurrentModal !== null &&
    targetRecurrentModal === undefined &&
    otherRecurrentModal
  ) {
    const newRecurrentModalStorage = recurrentModal.concat(newRecurrentModal);
    setRecurrentModalStorage(newRecurrentModalStorage);
  }

  const goReview = (): void => {
    const newRecurrentModal_ = {
      id: modalID,
      readDay: formatDate(new Date(), 'yyyyMMdd'),
      hidden: true,
    } as RecurrentModalProps;

    // memo: 更新されてる可能性があるため取得しなおす
    const { otherRecurrentModal } = getRecurrentModalStorage(modalID);

    const newRecurrentModal =
      otherRecurrentModal === undefined
        ? [newRecurrentModal_]
        : otherRecurrentModal.concat(newRecurrentModal_);
    setRecurrentModalStorage(newRecurrentModal);

    hideModal();
  };

  const showLater = (): void => {
    const newRecurrentModal_ = {
      id: modalID,
      readDay: formatDate(new Date(), 'yyyyMMdd'),
      // memo: 「今後表示しない」の状態を最優先にする
      hidden: isNotShowAgain,
    } as RecurrentModalProps;

    // memo: 更新されてる可能性があるため取得しなおす
    const { otherRecurrentModal } = getRecurrentModalStorage(modalID);

    const newRecurrentModal =
      otherRecurrentModal === undefined
        ? [newRecurrentModal_]
        : otherRecurrentModal.concat(newRecurrentModal_);
    setRecurrentModalStorage(newRecurrentModal);

    hideModal();
  };

  return (
    <>
      {modalID === 'dividendQuestionary' && (
        <DividendQuestionaryModal
          {...{
            isShow,
            isNotShowAgain,
            setIsNotShowAgain,
            goReview,
            showLater,
            modalID,
          }}
        />
      )}
      {modalID === 'androidReview' && (
        <AndroidReviewModal
          {...{
            isShow,
            isNotShowAgain,
            setIsNotShowAgain,
            goReview,
            showLater,
            modalID,
          }}
        />
      )}
    </>
  );
};

export const RecurrentModal = ({ modalID }: { modalID: ModalID }) => {
  const newDividendQuestionary = {
    id: modalID,
    readDay: null,
    hidden: false,
  } as RecurrentModalProps;

  const recurrentModal = getRecurrentModalStorage_();
  if (recurrentModal === null || recurrentModal === undefined) {
    setRecurrentModalStorage([newDividendQuestionary]);
  }

  const dividendQuestionary =
    recurrentModal === null
      ? null
      : recurrentModal.find(list => list.id === modalID);

  if (
    recurrentModal !== null &&
    recurrentModal !== undefined &&
    dividendQuestionary === null
  ) {
    const updateRecurrentModal = recurrentModal.concat(newDividendQuestionary);
    setRecurrentModalStorage(updateRecurrentModal);
  }

  const today = new Date();
  const oneMonthAgo = new Date(today.setMonth(today.getMonth() - 1));
  const readDay =
    dividendQuestionary && dividendQuestionary.readDay !== null
      ? convertFromString(dividendQuestionary.readDay, false)
      : null;

  const isRedisplay =
    readDay !== null && readDay.getTime() < oneMonthAgo.getTime();

  return (
    <>
      {dividendQuestionary === null ||
      dividendQuestionary === undefined ||
      (!dividendQuestionary.hidden && (isRedisplay || readDay === null)) ? (
        <RecurrentModalInternal {...{ modalID }} />
      ) : (
        <></>
      )}
    </>
  );
};
